import { Injectable, inject } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from '@web/shared/module/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationHeaderService {
  private readonly auth = inject(AuthService);

  public appendAuthorizationHeader<Body>(
    request: HttpRequest<Body>,
  ): Observable<HttpRequest<Body>> {
    return this.auth.fetchAuthToken().pipe(
      map(({ token }) => {
        return request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }),
      catchError(() => of(request.clone())),
    );
  }
}
